import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useGetCustomer } from "../api/customers";

export default function useHubSpot() {
  const { data: customer } = useGetCustomer();
  // eslint-disable-next-line no-underscore-dangle
  const hubspot = useMemo(() => (typeof window !== "undefined" && window._hsq ? window._hsq : []), []);
  const { pathname } = useLocation();
  useEffect(() => {
    if (hubspot && pathname) {
      hubspot.push(["setPath", pathname]);
      hubspot.push(["trackPageView"]);
      if (customer) {
        hubspot.push(["identify", { email: customer.email }]);
      }
    }
  }, [pathname, hubspot, customer]);
}
